import React from 'react';
import {connect} from 'react-redux';
import DateTimeDisplay from "../Boilerplate/DateTimeDisplay";
import {Button, Card, Checkbox, Col, Divider, Row, Select} from "antd";
import AddressLink from "../AddressLink";
import UserSmall from "../Boilerplate/UserSmall";
import {compose} from "redux";
import {quickInviteUserEmailSingle, userWillBid} from "../../actions/bids";
import {CodeTag} from "../Boilerplate/CodeTag";
import {QuickInviteButton} from "../Boilerplate/QuickInviteButton";
import {canUpdate, canViewContacts} from "../Boilerplate/permissions";
import LinkButton from "../Boilerplate/LinkButton";
import ChatWall from "../Boilerplate/ChatWall";
import * as R from 'ramda';
import DateDisplay from "../Boilerplate/DateDisplay";
import {getBidContactStatusSummary} from "../../actions/bidcontacts";
import {CountdownTimer} from "../Boilerplate/CountdownTimer";

class BidDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      temp: null,
    };
  }

  componentDidMount() {
    const { bid } = this.props;
    window.scrollTo(0, 0);
    canViewContacts(bid) && this.props.onMount && this.props.onMount();
  }

  handleWillBid = value => {
    let willBid;
    if (value === 'accepted') willBid = true;
    else if (value === 'declined') willBid = false;
    else {
      return;
    }
    this.props.handleWillBid && this.props.handleWillBid(willBid)
  };

  render() {
    const { bid, profile, cache, onEdit, onQuickInvite, onConvert } = this.props;
    const rowWidth = 24;
    const keyWidth = 11;
    const valWidth = rowWidth - keyWidth;
    const redirectBidding = () => this.props.redirectBidding();
    const redirectNotBidding = () => this.props.redirectNotBidding();
    const redirectUndecided = () => this.props.redirectUndecided();
    const redirectPlanHolders = () => this.props.redirectPlanHolders();
    return <React.Fragment>
      <Row gutter={24} align='top'>
        <Col key='1' xs={24} lg={17}>
          <Card
            title={
              <React.Fragment>
                <span className='list-title'>{bid.resource.name} (#{bid.resource.number})</span>
              </React.Fragment>
            }
            extra={
              <div className='bid-dashboard-controls'>
                <Row>
                  <Col xs={0} sm={24}>
                    <QuickInviteButton disabled={!canUpdate(bid)} onInvite={onQuickInvite}/>
                    <LinkButton
                      to={(match) => '/bids/' + match.params.bidId + '/files/'}
                      icon='folder-open'
                      type='primary'
                    >
                      <span className='hidden inline visible-xl'>Files</span>
                    </LinkButton>
                    <Button icon='edit' onClick={onEdit} disabled={!canUpdate(bid)}>
                      <span className='hidden inline visible-xl'>Edit</span>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} sm={0}>
                    <Button icon='edit' onClick={onEdit} disabled={!canUpdate(bid)}>
                      <span className='hidden inline visible-xl'>Edit</span>
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} sm={0}>
                    <LinkButton
                      to={(match) => '/bids/' + match.params.bidId + '/files/'}
                      icon='folder-open'
                      type='primary'
                    >
                      <span className='hidden inline visible-xl'>Files</span>
                    </LinkButton>
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} sm={0}>
                    <QuickInviteButton disabled={!canUpdate(bid)} onInvite={onQuickInvite}/>
                  </Col>
                </Row>
              </div>
            }
            className='bid-dashboard-info bid-dashboard-column-card'
          >
            <Row>
              <Divider className={'margins-vertical-small'} orientation={'left'}>Description</Divider>
              <p className='formatted-text text-column'>{bid.resource.description}</p>
            </Row>
          </Card>
          <Row type='flex' gutter={24}>
            <Col xs={24} md={12} className='bid-dashboard-info'>
              <Card
                title='Bid Details'
                className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card'
                extra={
                  bid.resource.status === 'pastdue' && canUpdate(bid) && this.props.projectcreator &&
                  <div className='bid-dashboard-controls'><Row><Col>
                    <Button icon='project' onClick={onConvert}>
                      <span>Convert to Project</span>
                    </Button>
                  </Col></Row></div>
                }
              >
                <Row className='key-value'>
                  <Col span={keyWidth}>Site Address</Col>
                  <Col span={valWidth}>
                    <AddressLink style={{fontSize: 16, fontWeight: 600}} address={{
                      street: [bid.resource.address, bid.resource.address2].join('\n'),
                      city: bid.resource.city,
                      state: bid.resource.state,
                      zip: bid.resource.zip
                    }}/>
                  </Col>
                </Row>
                <br/>
                <br/>
                <Row className='key-value' style={{display: bid.resource.createdbycompanyid === profile.companyid && 'none'}}>
                  <Col span={keyWidth}>Will you be bidding?</Col>
                  <Col span={valWidth}>
                    <Select
                      size='small'
                      placeholder='Select an option...'
                      style={{ minWidth: '150px'}}
                      value={bid.resource.contactstatus}
                      onChange={this.handleWillBid}
                    >
                      <Select.Option value='accepted'>Yes</Select.Option>
                      <Select.Option value='declined'>No</Select.Option>
                    </Select>
                  </Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Status</Col>
                  <Col span={valWidth}><CodeTag table='bidstatus' code={bid.resource.status}/></Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Estimated Cost</Col>
                  <Col span={valWidth}>$ {bid.resource.contractsize && bid.resource.contractsize.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</Col>
                </Row>
                {bid.resource.estimatedcost &&
                <Row className='key-value'>
                  <Col span={keyWidth}>Estimated Cost (Free Text)</Col>
                  <Col span={valWidth}>{bid.resource.estimatedcost}</Col>
                </Row>
                }
                <Row className='key-value'>
                  <Col span={keyWidth}>Date Opened</Col>
                  <Col span={valWidth}><DateDisplay date={bid.resource.dateopened}/></Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Bid Due Date</Col>
                  <Col span={valWidth}><DateTimeDisplay date={bid.resource.bidduedatetime}/></Col>
                </Row>
                { bid.resource.bidduedatetime &&
                <Row className='key-value'>
                  <Col span={keyWidth}>Bid Time Remaining</Col>
                  <Col span={valWidth}>
                    <CountdownTimer timestamp={bid.resource.bidduedatetime}/>
                  </Col>
                </Row>
                }
                <Row className='key-value'>
                  <Col span={keyWidth}>Proposals Bid To</Col>
                  <Col span={valWidth} className='formatted-text'>{bid.resource.proposalsbidto}</Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Bidders List</Col>
                  <Col span={valWidth} className='formatted-text'>{bid.resource.bidderslist}</Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Entered By</Col>
                  <Col span={valWidth}><UserSmall id={bid.resource.owneruserid}/></Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Addenda</Col>
                  <Col span={valWidth}>{bid.resource.addendums}</Col>
                </Row>
                {canViewContacts(bid) && <React.Fragment>
                  <Divider>Bidders Summary</Divider>
                  <a onClick={redirectPlanHolders} className='hover-underline'><Row className='color-primary-0'>
                    <Col span={keyWidth}/><Col span={valWidth} style={{padding: '0 10px'}}>View Plan Holders</Col>
                  </Row></a>
                  <br/>
                  <a onClick={redirectBidding} className='hover-underline'><Row className='key-value color-secondary-2-0'>
                    <Col span={keyWidth}>Bidding</Col>
                    <Col span={valWidth}>{cache.accepted}</Col>
                  </Row></a>
                  <a onClick={redirectNotBidding} className='hover-underline'><Row className='key-value color-complement-0'>
                    <Col span={keyWidth}>Not Bidding</Col>
                    <Col span={valWidth}>{cache.declined}</Col>
                  </Row></a>
                  <a onClick={redirectUndecided} className='hover-underline'><Row className='key-value color-primary-0'>
                    <Col span={keyWidth}>Undecided</Col>
                    <Col span={valWidth}>{cache.pending}</Col>
                  </Row></a>
                  {/*<br/>*/}
                  {/*<Row className='key-value'>*/}
                  {/*  <Col span={keyWidth}>Third-Party Contacts</Col>*/}
                  {/*  <Col span={valWidth}><Checkbox checked={bid.resource.thirdpartycontacts}/></Col>*/}
                  {/*</Row>*/}
                </React.Fragment>}
              </Card>
            </Col>
            <Col xs={24} md={12} className='bid-dashboard-info'>
              <Card title='Bid Information' className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card'>
                <Row className='key-value'>
                  <Col span={keyWidth}>Architect</Col>
                  <Col span={valWidth} className='formatted-text'>{bid.resource.architectname}</Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Engineer</Col>
                  <Col span={valWidth} className='formatted-text'>{bid.resource.engineername}</Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Site Owner</Col>
                  <Col span={valWidth} className='formatted-text'>{bid.resource.siteownername}</Col>
                </Row>
                <Divider>CSI Codes</Divider>
                <Row>
                  <Col span={rowWidth}>
                    {bid.resource.csicodes && bid.resource.csicodes.map(code =>
                      <CodeTag table='csi' key={code} code={code}/>)}
                  </Col>
                </Row>
                <Divider>Industries</Divider>
                <Row>
                  <Col span={rowWidth}>
                    {bid.resource.industries && bid.resource.industries.map(code =>
                      <CodeTag table='industry' key={code} code={code}/>)}
                  </Col>
                </Row>
                <Divider>Sectors</Divider>
                <Row>
                  <Col span={rowWidth}>
                    {bid.resource.sectors && bid.resource.sectors.map(code =>
                      <CodeTag table='sector' key={code} code={code}/>)}
                  </Col>
                </Row>
                <Divider>Set Asides</Divider>
                <Row>
                  <Col span={rowWidth}>
                    {bid.resource.setasides && bid.resource.setasides.map(code =>
                      <CodeTag table='setaside' key={code} code={code}/>)}
                  </Col>
                </Row>
                <Divider/>
                <Row className='bid-dashboard-boolean-flags'>
                  <Col span={8}><Checkbox checked={bid.resource.newconstruction}>New Construction</Checkbox></Col>
                  <Col span={8}><Checkbox checked={bid.resource.unionized}>Union</Checkbox></Col>
                  <Col span={8}><Checkbox checked={bid.resource.certifiedpayroll}>Certified Payroll</Checkbox></Col>
                </Row>
                <Row>
                  <Col span={8}><Checkbox checked={bid.resource.prevailingwage}>Prevailing Wage</Checkbox></Col>
                  <Col span={8}><Checkbox checked={bid.resource.ccipinsurance}>CCIP Insurance</Checkbox></Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <Row type='flex' gutter={24}>
            <Col xs={24} md={12} className='bid-dashboard-info'>
              <Card title='Pre-Bid' className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card'>
                <Row className='key-value'>
                  <Col span={keyWidth}>Pre Bid Meeting</Col>
                  <Col span={valWidth}><Checkbox checked={bid.resource.prebidmeeting}/></Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Mandatory</Col>
                  <Col span={valWidth}><Checkbox checked={bid.resource.prebidmeetingrequired}/></Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Meeting Date</Col>
                  <Col span={valWidth} className={bid.resource.prebidmeetingrequired && 'color-secondary-1-0 strong-text'}>
                    <DateTimeDisplay date={bid.resource.prebidmeetingdatetime}/>
                  </Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Meeting Location</Col>
                  <Col span={valWidth} className={bid.resource.prebidmeetingrequired && 'color-secondary-1-0 strong-text'}>
                    <AddressLink className={bid.resource.prebidmeetingrequired && 'color-secondary-1-0 strong-text'}
                                 rawaddress={bid.resource.prebidmeetinglocation}/>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col key='4' xs={24} lg={7} className='bid-dashboard-info'>
          <ChatWall bidId={bid.resource.id}/>
        </Col>
      </Row>
    </React.Fragment>
  };
}

export default compose(
  connect(
    (state, ownProps) => {
      let bid = state.view.data[ownProps.match.params.bidId];
      bid = {
        ...bid,
        resource: {
          ...bid.resource,
          company: state.companies.data[(bid.resource || {}).ownercompanyid]
        }
      };

      const cache = R.path(['bidcontacts', 'data', ownProps.match.params.bidId, 'cache'], state) || {};
      const projectcreator = R.view(R.lensPath(['ui', 'authData', 'createProjects']), state);

      if (!R.includes(bid.resource.contactstatus, ['accepted', 'declined'])) {
        bid = R.set(R.lensPath(['resource','contactstatus']), undefined, bid);
      }

      return {
        bid,
        profile: state.profile,
        cache,
        projectcreator,
      };
    },
    (dispatch, props) => ({
      onMount: () => dispatch(getBidContactStatusSummary(props.match.params.bidId)),
      onEdit: () => props.history.push('/bids/' + props.match.params.bidId + '/edit'),
      onQuickInvite: (email) => dispatch(quickInviteUserEmailSingle(props.match.params.bidId, email)),
      onConvert: () => props.history.push(`/bids/${props.match.params.bidId}/convert`),
      handleWillBid: isBidding => dispatch(userWillBid(props.match.params.bidId, isBidding)),
      redirectBidding: () => props.history.push('/bids/' + props.match.params.bidId + '/contacts/bidding'),
      redirectNotBidding: () => props.history.push('/bids/' + props.match.params.bidId + '/contacts/notbidding'),
      redirectUndecided: () => props.history.push('/bids/' + props.match.params.bidId + '/contacts/undecided'),
      redirectPlanHolders: () => props.history.push('/bids/' + props.match.params.bidId + '/contacts/planholders'),
    }))
)(BidDashboard);



// WEBPACK FOOTER //
// ./src/components/Bids/BidDashboard.js